import styled, { css, keyframes } from 'styled-components';

export const ChangeDomainWrapper = styled.div`
  ${({ theme, $centered }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    gap: 40px;
    justify-content: ${$centered ? 'center' : 'flex-start'};
    min-height: 100%;
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    max-width: fit-content;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px 20px;
      width: calc(100% - 40px);
      span {
        font-size: ${theme.v2.font.sizes.xxs};
      }
    }
  `}
`;

export const BreadCrumbsWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v2.breakpoints.md}) {
      span {
        font-size: ${theme.v2.font.sizes.xxs};
      }
    }
  `}
`;

export const LogoRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    border-bottom: 1px solid ${theme.v2.colors.neutral.highLight};
    display: flex;
    justify-content: center;
    padding: 20px 0;
  `}
`;

export const LoadingLogoRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-bottom: 1px solid ${theme.v2.colors.neutral.highLight};
    display: flex;
    justify-content: center;
    padding: 20px 0;
  `}
`;

export const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-start;
`;

export const BreadcrumbItem = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 8px 4px;
    text-decoration: underline;
    display: flex;
    align-item: center;

    &:last-child {
      font-weight: ${theme.v2.font.weights.regular};
      text-decoration: unset;
      color: ${theme.v2.colors.neutral.lowMedium};
    }
  `}
`;

export const SkeletonWrapper = styled(ChangeDomainWrapper)`
  ${({ theme }) => css`
    gap: 0;
    width: 738px;

    @media(max-width: ${theme.v2.breakpoints.md}) {
      padding: 0px 20px;
      width: calc(100% - 40px);
    }
  `};
`;

export const TopContent = styled.div`
  align-items: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
  width: 100%;

  & > :first-child {
    margin-bottom: 40px;
  }
`;

export const BottomContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 48px;
  width: 100%;
`;

export const LoaderWrapper = styled.div`
  height: calc(100% - 62px);
`;

export const LoadWrapper = styled.div`
  margin: 0 auto 0 auto;
  position: absolute;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1000;
`;

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;


export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    > div {
      background-color: ${theme.v2.colors.feedback.problemMedium};
      border-radius: 8px;
      box-shadow: 0px 0px 1px 0px #707070;
    }
    svg {
      fill: ${theme.v2.colors.neutral.highPure};
      stroke: ${theme.v2.colors.neutral.highPure};
    }
    p {
      color: ${theme.v2.colors.neutral.highPure};
    }
    button {
      top: 50%;
      transform: translateY(-50%);
    }
    bottom: 85px;
    position: fixed;
    max-width: 469px;
    right: 62px;
    width: 100%;
    animation: ${slideIn} 0.5s ease-out;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      position: absolute;
      left: 20px;
      right: 20px;
      margin: 0 auto;
      width: auto;
    }
  `}
`;
